import { http, api } from '../../../libs/util';
const util = {
  create_types: [
    {label: '按次', value: 'per_time', comment: '每条流水生成一张单据'},
    {label: '按天汇总', value: 'per_day', comment: '每天汇总生成一次'},
  ],
  linke_params:() => {
    return {
      related_type: 'expense_group'
    }
  },
  new_expense_rule: {
    rule_name: '',
    remark_reg: '',
    opposite_reg: '',
    expense_group_name: '',
    apply_user_id: 0,
    apply_user: 0,
    expense_type_id: 0,
    team_id: 0,
    payee_company_account_id: 0,
    payee_account_name: '',
    payee_bank_number: '',
    create_type: 'per_time',
    del: 0
  },
  new_income_rule: {
    total_amount: null,
    invoice_type: '',
    contact_unit_type: '', // 来往单位类型
    rule_name: '',
    remark_reg: '',
    trscod_reg: '', //  交易代码规则
    opposite_reg: '',
    bill_name: '',
    apply_user_id: 0,
    purpose_id: 0,
    gen_sk_bill: false,
    gen_ys_bill: false,
    gen_jt_bill: false,
    team_id: 0,
    supplier_account_id: 0,
    supplier_account_name: '',
    supplier_bank_number: '',
    create_type: 'per_time',
    del: 0
  },
  initData: () => ({
    verified_date_type:null,
    contract_id:null,
    invoice_type:null,
    tax:null, 
    tax_rate:null, 
    total_amount:null,
    account_title_id:null, 
    analysis_title_id:null, 
    customer_function_id:null,
    customer_type:null,
    expense_nature_id:null, 
    fund_usage_id:null, 
    is_insider_trading:null, 
    item_type_id:null,
    apply_user:null, 
    apply_user_id:null,
    create_type:'per_time',
    expense_group_name:null,
    payee_account_name:null, 
    payee_bank_number:null,
    payee_company_account_id:null, 
    remark_reg:null, 
    rule_name:null,
    opposite_reg:null,
    team_id:null,
    trscod_reg: null,
  }),
  getItemLinkedRelations(id) {
    return http.get(api.bank_statement_item_linked_relations, { id });
  },
  releaseItemLinkedRelations(params) {
    return http.post(api.release_bank_statement_item_linked_relations, params);
  },
};

const create_type_hash = util.create_types.toHash('value', 'label');
util.getCreateTypeName = (type) => {
  return create_type_hash[type] || '未定义类型';
};

export default util;
